export enum SoftCheckResponse {
  Valid = 'Valid',
  Invalid = 'Invalid',
}
